export const TrackpadIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="55" height="51" viewBox="0 0 55 51" fill="none">
      <rect
        x="54.1812"
        y="0.75"
        width="40.506"
        height="53.431"
        rx="10.1423"
        transform="rotate(90 54.1812 0.75)"
        stroke="#B9BCCB"
        strokeWidth="1.5"
      />
      <path
        d="M27.924 43.7539L23.9995 37.9761C33.9616 37.0572 40.0375 36.6728 49.9995 35.7539V41.401L48.5823 43.2833L27.924 43.7539Z"
        fill="white"
      />
      <path
        d="M29.9847 34.4375L24.5579 20.6814C24.3039 20.0376 24.3161 19.3193 24.5917 18.6844C24.8674 18.0496 25.3839 17.5502 26.0278 17.2962C26.6716 17.0422 27.3899 17.0544 28.0248 17.3301C28.6596 17.6057 29.159 18.1223 29.413 18.7661L34.2014 30.9038"
        stroke="#848199"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4924 30.4076V17.1326C34.4924 16.4405 34.7674 15.7767 35.2568 15.2873C35.7462 14.7979 36.4099 14.5229 37.102 14.5229C37.7942 14.5229 38.4579 14.7979 38.9473 15.2873C39.4367 15.7767 39.7117 16.4405 39.7117 17.1326V29.9386"
        stroke="#848199"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.8961 29.9582C39.8961 29.2661 40.1711 28.6024 40.6605 28.113C41.1499 27.6236 41.8136 27.3486 42.5057 27.3486C43.1978 27.3486 43.8616 27.6236 44.351 28.113C44.8404 28.6024 45.1153 29.2661 45.1153 29.9582V32.5679"
        stroke="#848199"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.1155 31.698C45.1155 31.0059 45.3904 30.3421 45.8798 29.8527C46.3692 29.3633 47.033 29.0884 47.7251 29.0884C48.4172 29.0884 49.081 29.3633 49.5704 29.8527C50.0598 30.3421 50.3347 31.0059 50.3347 31.698V39.5268C50.3347 42.2953 49.235 44.9504 47.2774 46.9079C45.3198 48.8655 42.6647 49.9653 39.8963 49.9653H36.4168H36.7786C35.0499 49.9656 33.3482 49.5365 31.8263 48.7167C30.3043 47.8968 29.0098 46.7118 28.059 45.268L27.7181 44.7461C27.1753 43.9127 25.2702 40.5916 22.0013 34.7808C21.668 34.1885 21.579 33.4895 21.7531 32.8326C21.9273 32.1756 22.3509 31.6125 22.9338 31.2631C23.5546 30.8905 24.2822 30.7361 25.0009 30.8244C25.7195 30.9126 26.3881 31.2385 26.9004 31.7502L29.4578 34.3076"
        stroke="#848199"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8978 29.5417L13.2538 29.822C12.9763 29.8433 12.7451 29.6122 12.7665 29.3347L13.0468 25.6907"
        stroke="#FFB4C9"
        strokeWidth="1.81538"
        strokeLinecap="round"
      />
      <path d="M18.9696 23.8013L14.0096 28.5787" stroke="#FFB4C9" strokeWidth="1.81538" strokeLinecap="round" />
      <path
        d="M32.8605 6.78549L36.5045 6.50518C36.782 6.48383 37.0132 6.715 36.9918 6.9925L36.7115 10.6365"
        stroke="#FFB4C9"
        strokeWidth="1.81538"
        strokeLinecap="round"
      />
      <path d="M30.7887 12.5259L35.7487 7.74849" stroke="#FFB4C9" strokeWidth="1.81538" strokeLinecap="round" />
    </svg>
  );
};
